import { useMount } from './useMount.js';
import { useRef } from 'react';
/**
 * A hook that tracks if the component has mounted.
 *
 * This hook uses a `ref` to track the mount status of the component. Since updating a ref does not trigger a re-render,
 * the value of `hasMounted` will not cause the component to update when it changes.
 * Note that due to the non-reactive nature of this hook, `hasMounted` should be used with caution
 * in scenarios where a re-render based on the mount status is required.
 */
export const useHasMounted = () => {
    const hasMountedRef = useRef(false);
    const hasMounted = hasMountedRef.current;
    useMount(() => {
        hasMountedRef.current = true;
        return () => {
            hasMountedRef.current = false;
        };
    });
    return {
        hasMounted,
    };
};
//# sourceMappingURL=useHasMounted.js.map